import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'sa-ui';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from './simulatedQuestionsMessages';


/*
  <div className="card text-center pt-5 pb-5">
              <div className="card-body pl-2 pr-2 pt-5 pb-5">
                <i className="icon ti-check-box" />
                <h5 className="title card-title card-title-big">
                  {intl.formatMessage(messages.approved)}
                </h5>
                <p className="subtitle subtitle-big w-75 m-auto">
                  {intl.formatMessage(messages.approvedMessage, {
                    question: 23,
                  })}
                </p>
                <div className="w-75 m-auto p-3">
                  <button className="btn btn-outline-primary btn-outline-primary-rose mr-1">
                    {intl.formatMessage(messages.back)}
                  </button>
                  <button className="btn btn-primary btn-primary-rose ml-1">
                    <strong>{intl.formatMessage(messages.continue)}</strong>
                  </button>
                </div>
              </div>
            </div>
*/
const ApproveQuestionModal = props => {
    return (
        <Modal
        show={props.show}
        onClose={props.onClose}
        icon="ti-check-box"
        title={<FormattedMessage {...messages.approved} values={props.question}/>}
        buttons={[
            {
              label: <FormattedMessage {...messages.close} />,
              onClick: props.onClose,
            },
          ]}
      >
        <div class="mt-3">
        <FormattedMessage
          {...messages.approvedMessage}
          values={props.question}
        />
        </div>
      </Modal>
    );
};

ApproveQuestionModal.propTypes = {
    
};

export default ApproveQuestionModal;